// Dynamic environment configuration loader
// This file dynamically imports the correct environment config based on CLIENT_ENV

// Use process.env directly to ensure webpack can optimize this during build time
let config;

if (process.env.CLIENT_ENV === 'production') {
  config = require('./environments/production.ts').default;
} else if (process.env.CLIENT_ENV === 'staging') {
  config = require('./environments/staging.ts').default;
} else {
  config = require('./environments/development.ts').default;
}

export default config;